  $(document).ready(function(){
     setTimeout(function() {
    $(".product-blcok-iconText").show();
     $(".cubynEstimatedDeliveryTime").wrap("<div class='containerdeliverytext'></div>");
     $(".containerdeliverytext").append('<span class="product-blcok-iconText">🚚 Livraison gratuite -</span>');
     }, 3500);
    

   setTimeout(function() {$('section a:contains("Skio Secured")').addClass('remove-links');}, 1000);
 
    
 /* subscription variants */
   $(".subscription :radio").on("change",function(){ 
      if( $(this).is(":checked") ){ 
            var val = $(this).attr("data-attr"); 
           var selected_ids= $(this).attr("data-id");
               $(".option-trigger-"+val).trigger("click");
         $(".new-form-options").removeClass("selectedWB");
            $("#new-form #id"+selected_ids).trigger("click");
        
        }


    });
    
function ProgressiveBar(cart){          
          var thsld = $('.cart-progress-bar').data('throshold');
          var pprr = cart.items_subtotal_price;
     
          if(thsld > pprr){
            var leftItem = pprr / 100;
            var finalRemain = leftItem * 100;
            var remainss = 5500 - pprr;
            var leftItem = pprr / 100;
            var finalRemain = leftItem * 100;
            var remainss = 5500 - pprr;
            var remainss1 = 8500 - pprr;
            var main_remain=remainss /100;
           
            if(leftItem <= 10){
              var minuss = leftItem - 2;
            }
            else if(leftItem <= 20 && leftItem > 10){
              var minuss = leftItem - 5;
            }
            else if(leftItem <= 30 && leftItem > 20){
              var minuss = leftItem - 7;
            }
            else if(leftItem <= 40 && leftItem > 30){
              var minuss = leftItem - 9;
            }
            else if(leftItem <= 55 && leftItem > 40){
              var minuss = leftItem -2 +2;
            }
              else if(leftItem <= 65 && leftItem > 55){
              var minuss = leftItem -5 +6;
            }
              else if(leftItem <= 75 && leftItem > 65){
              var minuss = leftItem -3;
            }
                 else if(leftItem <= 80 && leftItem > 75){
              var minuss = leftItem - 2;
            }
              else if(leftItem <= 85 && leftItem > 80){
              var minuss = leftItem - 1;
            }
           else if(leftItem > 85){
              var minuss = leftItem+10;
            }
            $('.cart__bar .cart__progress').css('width',(minuss)+'%');
            if(pprr <= 5500){
            
            $('.cart__shipping-text .completionWording').html('Plus que <span class="remianing-price"> '+main_remain+'€ </span>pour la livraison gratuite').css('color','#000');

            }else if(pprr < thsld && pprr > 5500){
            
              $('.cart__shipping-text p').html("Bravo ! La livraison est offerte").css('color','green').addClass('cart__shipping-text-new-custom');

            }
             else{
           
         $('.cart__bar .cart__progress').css('width','100%');
            $('.cart__shipping-text p').html("Excellent choix !").css('color','green');
          }
            
          }
          else{
           
         $('.cart__bar .cart__progress').css('width','100%');
            $('.cart__shipping-text p').html("Excellent choix !").css('color','green');
          }
          
          
        }
   

    
  });